<template>
  <div class="one-footer">
    <div class="footer-inner">
      <el-row>
        <el-col :span="6" class="textalignleft">
          <img src="../assets/image/logo.png" alt="" class="logoimg">
          <div class="logo-text">Ragana，与你相练</div>
        </el-col>
        <el-col :span="12">
          <div class="footer-tel">
            TEL: 0351-2379580
          </div>
          <div class="footer-time">
            工作时间：8:00 - 17:30（工作日）
          </div>
          <div class="footer-address">
            公司地址：山西省太原市万柏林区-迎泽西大街86号 信达国际金融中心52层
          </div>
        </el-col>
        <el-col :span="6" class="textalignright">
          <img src="../assets/image/qcode.png" alt="" class="qcodeimg">
          <div class="qcode-text logo-text">Ragana小程序</div>
        </el-col>
      </el-row>

    </div>
    <div class="footer-line"></div>
    <el-row>
      <el-col :span="24">
        <div class="footer-text">
          <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">津ICP备2022008875号</a> <span>天津万唯计算机技术有限公司</span> <span>网站应用服务</span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.one-footer {
  width: 100%;
  height: 261px !important;
  background: #222222;
  font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
  color: #FFFFFF;
  font-weight: 400;

  .footer-line {
    width: 100%;
    height: 1px;
    background: #3D3D3D;
    opacity: 1;
    margin-top: 30px;
    // border: 1px solid #3D3D3D;
  }

  .footer-text {
    width: 100%;
    text-align: center;
    font-size: 12px;
    font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
    font-weight: 400;
    color: #666666;
    line-height: 22px;
    margin: 12px auto;
    a{
      color: #666666;
    }
    a:hover{
      color:#E50A33
    }
  }

  .footer-inner {
    width: calc(100% - 360px);
    margin: 0 auto;

    .footer-tel {
      width: 100%;
      text-align: center;
      font-size: 30px;
      font-family: BebasNeue;
      color: #F3F3F3;
      line-height: 44px;
      margin-top: 50px;
    }

    .footer-time {
      width: 100%;
      text-align: center;
      font-size: 14px;
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      color: #F3F3F3;
      line-height: 29px;
      margin: 8px auto;
    }

    .footer-address {
      width: 100%;
      text-align: center;
      font-size: 14px;
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      color: #F3F3F3;
      line-height: 10px;
    }

    .textalignleft {
      text-align: left;
    }

    .textalignright {
      text-align: right;
    }

    .logoimg {
      width: 140px;
      height: 42px;
      // margin-bottom: 12px;
      margin-top: 68px;
    }

    .qcodeimg {
      width: 120px;
      height: 120px;
      margin-top: 31px;
    }

    .logo-text {
      width: 100%;
      font-size: 14px;
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 26px;
      text-align: left;
      display: inline-block;
    } 
    .qcode-text {
      text-align: right;
      padding-right: 10px;
      box-sizing: border-box;
    }


  }
}
</style>
